import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { AUTH_ERROR_EVENT } from '@/api/client';

// Wraps the authed routes. Three jobs:
//   1) Gate render on a stored token (otherwise bounce to /login).
//   2) Listen for the AUTH_ERROR_EVENT raised by axios on 401 — clear store
//      and bounce. The store is already cleared in the interceptor; this
//      effect just forces a re-render so Navigate kicks in.
//   3) Preserve the original location so login can redirect back.
export function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const clear = useAuthStore((s) => s.clear);
  const location = useLocation();

  useEffect(() => {
    const onUnauthorized = () => {
      clear();
    };
    window.addEventListener(AUTH_ERROR_EVENT, onUnauthorized);
    return () => window.removeEventListener(AUTH_ERROR_EVENT, onUnauthorized);
  }, [clear]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
